import { FC, useEffect, useState } from 'react';
import { Checkbox } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useEntitlements } from '@/hooks/useEntitlements';
import { PlanTag } from '@/shared';

interface FundraisingProps {
    filters: any;
    handleChange: any;
}

const Fundraising: FC<FundraisingProps> = ({ filters, handleChange }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { hasMinimumPlan } = useEntitlements();
    const { token } = useAntDesignTheme();

    const ranksArray = [
        '$0 - $1M',
        '$1M - $10M',
        '$10M - $50M',
        '$50M - $100M',
        '$100M - $250M',
        '$250M - $500M',
        '$500M - $1B',
        '$1B - $10B',
        '$10B+',
    ];

    return !hasMinimumPlan('plus') ? (
        <div style={{ textAlign: 'center', margin: '2rem' }}>
            <PlanTag plan={'plus'} style={{ marginLeft: '0.5rem' }} />
        </div>
    ) : (
        <>
            <div style={{ marginBottom: '0.5rem' }}>
                <small style={{ color: token.colorTextTertiary }}>Capital Raised (in USD)</small>
            </div>
            <Checkbox.Group
                value={filters?.fundraising}
                onChange={(checkedValues) => {
                    handleChange(['fundraising'], checkedValues);
                }}
            >
                {ranksArray?.map((r: any) => {
                    return (
                        <div key={r} style={{ width: '100%' }}>
                            <Checkbox value={r}>{r}</Checkbox>
                        </div>
                    );
                })}
            </Checkbox.Group>
        </>
    );
};

export default Fundraising;
